import config from "../config.json";
import { createAxiosInstance } from "./ServicesHelpers";

const axiosInstance = createAxiosInstance(config.ADMIN_API_BASE_URL);

interface SetPasswordRequest {
  code: string;
  newPassword: string;
}

export async function setUserPassword(
  email: string,
  data: SetPasswordRequest
): Promise<void> {
  try {
    await axiosInstance.put(
      `/users/${encodeURIComponent(email)}/password`,
      data
    );
  } catch (error: any) {
    throw new Error(
      error.response?.data?.message ||
        "An error occurred while setting the new password."
    );
  }
}
